import styled from '@emotion/styled';

const Elem:React.FC<any> = () => {
  return (
    <Container>
      <TextStyle>8,900원</TextStyle>
    </Container>
  )
};

export default Elem;

const Container = styled.div`
  margin-right: 10px;
`;
const TextStyle = styled.span`
  position: relative;
  display: inline-block;
  color: rgba(178, 178, 178, 1);
  font-size: 11px;

  &::after {
    content: "";
    position: absolute;
    bottom: 45%;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: rgba(178, 178, 178, 1); /* 원하는 색상으로 변경할 수 있습니다 */
    pointer-events: none; /* 가상 요소를 클릭 가능하지 않게 설정 (선택사항) */
  }
`;